// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"396":"2e226d02","793":"e22235e4"}[chunkId] + ".chunk.css";
};